<template>
  <section class="cart account">
    <router-link :to="{ name: 'shop' }" class="btn btn--tertiary cart__shop-link"
      >Back to shop</router-link
    >
    <div class="cart__shop">
      <div class="cart__main account__cart-list">
        <ShoppingCartList />
      </div>
      <div class="account__cart-list--mobile">
        <ShoppingCartResume />
      </div>
      <div :class="['cart__aside account__aside', isAccountPage && 'cart__aside--account']">
        <div class="account__title-wrapper">
          <h4 class="account__title">Sign in or sign up to continue</h4>
          <AccountSignInUp />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import ShoppingCartList from '@/components/cart/ShoppingCartList.vue'
import ShoppingCartResume from '@/components/cart/ShoppingCartResume.vue'
import AccountSignInUp from '@/components/login/AccountSignInUp.vue'

export default {
  name: 'Account',
  components: {
    ShoppingCartList,
    AccountSignInUp,
    ShoppingCartResume,
  },
  computed: {
    ...mapState({
      customCoupon: state => state.shoppingCart.coupon,
      promotionalField: state => state.subscriptions.promotionalField,
      isModalShown: state => state.app.isNewAccountModalShown,
      shoppingCart: state => state.shoppingCart.shoppingCart,
    }),
    ...mapGetters({
      selectedPlan: 'shoppingCart/selectedPlan',
    }),
    streamingLink() {
      return `${process.env.VUE_APP_STREAMING_URL}`
    },
    redirectUrl() {
      return process.env.VUE_APP_REDIRECT_URL
    },
    isAccountPage() {
      return this.$route.name === 'account'
    },
  },
  watch: {
    shoppingCart: {
      immediate: true,
      handler(items) {
        if (items.length === 0) {
          this.$router.push({ name: 'shop' })
        }
      },
    },
  },
  methods: {
    ...mapMutations({
      setIsModalShown: 'app/IS_NEW_ACCOUNT_MODAL_SHOWN_UPDATED',
    }),
    buildRedirectUrl() {
      const {
        customCoupon: coupon,
        redirectUrl,
        selectedPlan: { merchant_id },
        streamingLink,
        promotionalField,
      } = this

      const arrParams = []
      let redirect = `https://${redirectUrl}`

      arrParams.push('to_payment=true')

      if (merchant_id && merchant_id.length) {
        arrParams.push(`plan=${merchant_id}`)
      }
      if (coupon && coupon.length) {
        arrParams.push(`coupon=${coupon}`)
      }
      if (promotionalField && promotionalField.length) {
        arrParams.push(`special_offer=${promotionalField}`)
      }

      if (arrParams.length) {
        redirect += `?${arrParams.join('&')}`
      }

      const encodedUrl = encodeURIComponent(redirect)
      window.location.assign(`https://${streamingLink}/login?redirect_url=${encodedUrl}`)
    },
    handleModal() {
      this.setIsModalShown(!this.isModalShown)
    },
  },
}
</script>

<style lang="scss">
.account {
  max-width: 1200px;
  padding: 0 20px;
  margin-bottom: 160px;
  @include mobile {
    padding: 0 25px;
    width: 100%;
    margin-bottom: unset;
  }
  @include tablet-ipad-air-and-mini-portrait {
    margin-bottom: 160px;
  }
  @include desktop {
    margin-bottom: 160px;
  }
  &__title {
    font-family: var(--font-regular);
    font-weight: 450;
    font-size: rem(24px);
    line-height: 32px;
    color: var(--white);
    margin: 0;
    margin-bottom: 20px;
    @include tablet {
      margin: 30px 0;
    }
    text-align: center;
  }
  .cart__shop {
    margin: 45px 0 0 0;
    background: none;
    @include tablet {
      margin: 25px 0 0 0;
      background: var(--black-2);
    }
  }
  &__cart-list {
    display: none;
    &--mobile {
      display: block;
      margin-bottom: 20px;
      width: 100%;
    }
    @include tablet {
      display: block;
      &--mobile {
        display: none;
      }
    }
  }
  &__aside {
    background: var(--mid-gray-gradient);
    border-radius: 25px;
    padding: 40px 20px;
    @include mobile {
      padding: 40px 70px;
    }
  }
}
</style>
